
import Vue from 'vue'

import ProjectModel from '@/views/Project/Project/models/project'
import ProjectMixin from '@/_mixins/project'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { serialise } from 'kitsu-core'
const PostModuleDialog = Vue.extend({
    mixins: [ProjectMixin],
    components: { DialogTemplate },
    props: {
        props: {
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: false,
            bklrProject: null,
            requestForNewCardReaders: false,
            requestTransferOfExistingCardReaders: '',
        }
    },

    computed: {
        moduleId(): string {
            return this.props.moduleId
        },

        project(): ProjectModel {
            return this.props.project
        },
        bkrlProjects() {
            return this.$store.getters.bklrProjectsFull
        },
        company() {
            return this.currentProject?.relationships.owner?.data?.id
                ? this.$store.getters.projectCompany(
                      this.currentProject.relationships.owner.data.id
                  )?.attributes?.name
                : null
        },
        moduleParams() {
            const filters: Record<string, string | boolean> = {}
            if (this.requestForNewCardReaders) {
                filters.requestContactForNewCardReaders = true
            }
            if (this.requestTransferOfExistingCardReaders) {
                filters.requestTransferOfExistingCardReaders =
                    this.requestTransferOfExistingCardReaders
            }
            return filters
        },
    },

    methods: {
        async post() {
            let projectModule = null
            this.loading = true

            try {
                projectModule = await this.project
                    .postModule(this.moduleId, this.project, this.moduleParams)
                    .catch(async (error) => {
                        if (error.code == 'moduleAlreadyExists') {
                            this.$store.commit('closeSnackbar')
                            let res = await this.project.get(['modules'])

                            if (res.data) {
                                this.$emit('close', res)
                            }
                        } else {
                            error = true
                        }
                    })
                if (projectModule) {
                    if (this.moduleId == 'personnel' && !this.project.bklrId) {
                        if (this.bklrProject) {
                            await this.project.patch(
                                serialise('project', {
                                    id: this.project._id,
                                    bklrId: this.bklrProject,
                                }).data
                            )
                        } else if (this.project.canCreateBklrProject) {
                            await this.project.createBklrProject(this.project._id)
                        }
                    }
                }
            } finally {
                if (projectModule) {
                    this.$emit('close', projectModule)
                }
                // Temporary solution to load modules after adding new one
                await this.getProject(this.$route.params.id)
                this.loading = false
            }
        },
    },
    mounted() {
        if (this.moduleId == 'personnel') {
            this.bklrProject = this.project.bklrId
        }
    },
})
export default PostModuleDialog
